import getQueryString from './getUrlQuery';
const report = (obj = {}) => {
  const rosdata = getQueryString('from') || getQueryString('rso') || '';
  const source = {
    pro: 'huya_hd', // 产品给的
    pas: window.YA.cookie.get('username') || '',
    yyuid: window.YA.cookie.get('yyuid') || '',
    pageType: 'root',
    rso: rosdata,
    rso_desc: '',
    eid: '',
    eid_desc: '',
  };
  const reportData = Object.assign(source, obj);
  // console.log('TCL:>> 数据上报 ==>', reportData.prop, reportData.eid);

  if (!window.yareport) {
    window.yareport = new window.YA(source.pro, source.pas, {
      pageType: reportData.pageType,
      yyuid: reportData.yyuid,
    });
    window.yareport.reportProductStartUp({
      pro: reportData.pro,
      rso: reportData.rso,
      rso_desc: reportData.rso_desc,
    });

    window.yareport.startProductHeartbeat({
      pro: reportData.pro,
      rso: reportData.rso,
      rso_desc: reportData.rso_desc,
    });
    window.yareport.reportProductEvent(reportData);
  } else {
    window.yareport.reportProductEvent(reportData);
  }
};
export default report;
